const orders = [
    {
        id: 1,
        orderNo: "B24/060004",
        orderDate: "2021-09-01",
        paymentDate: "2021-09-01",
        amount: 21990.0,
        paymentMethod: "QR Prompt Pay",

        status: "paid",

        details: [
            {
                name: `Voucher ตั๋วเครื่องบิน กรุงเทพ - มาเก๊า *(ตั๋วเที่ยวเดียว)`,
                price: 500.0,
                quantity: 8,
                total: 15992.0,
            },
            {
                name: `Voucher ตั๋วเครื่องบิน กรุงเทพ - มาเก๊า + กระเป๋า *(ตั๋วเที่ยวเดียว)`,
                price: 500.0,
                quantity: 2,
                total: 5998.0,
            },
        ],
    },
    {
        id: 2,
        orderNo: "B24/060003",
        orderDate: "2021-09-01",
        paymentDate: null,
        amount: 1000.0,
        paymentMethod: "QR Prompt Pay",

        status: "pending",
        expiredDate: "2021-09-01",

        details: [
            {
                name: `Voucher ตั๋วเครื่องบิน กรุงเทพ - มาเก๊า *(ตั๋วเที่ยวเดียว)`,
                quantity: 2,
                total: 3998.0,
            },
        ],
    },
    {
        id: 3,
        orderNo: "B24/060002",
        orderDate: "03/06/2024 12:12",
        paymentDate: null,
        amount: 1999.0,
        paymentMethod: "QR Prompt Pay",

        status: "expired",

        details: [
            {
                name: `Voucher ตั๋วเครื่องบิน กรุงเทพ - มาเก๊า *(ตั๋วเที่ยวเดียว)`,
                quantity: 1,
                total: 1999.0,
            },
        ],
    },
    {
        id: 4,
        orderNo: "B24/060001",
        orderDate: "03/06/2024 12:12",
        paymentDate: null,
        amount: 2999.0,
        paymentMethod: "QR Prompt Pay",

        status: "cancelled",
        cancelledDate: "03/06/2024 12:12",

        details: [
            {
                name: `Voucher ตั๋วเครื่องบิน กรุงเทพ - มาเก๊า + กระเป๋า`,
                quantity: 1,
                total: 2999.0,
            },
        ],
    },
];

export default {
    data: orders,

    meta: {
        total: orders.length,
        current_page: 1,
        per_page: 10,
        last_page: 1,
    },
};
